import { Injectable } from '@angular/core';
import { WebApiService } from 'src/app/shared/web-api/web-api.service';
import { PickListProperties } from '../kendo/grid/picklist-properties';

@Injectable({
  providedIn: 'root'
})
export class PicklistService {

  constructor(private webApiService: WebApiService) { }

  getPicklistValues(id: string) {
    return this.webApiService.get<PickListProperties>(`/configuration/system/picklistgroups/${id}`);
  }

  getPicklistValuesForProject(picklistId: string, projectId: string) {
    return this.webApiService.get<PickListProperties>(`/configuration/projects/${projectId}/picklistgroups/${picklistId}`);
  }
}
